import React from 'react';
import { Box, Typography, Paper, IconButton } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface GrossEarningsCardProps {
    amount: string;
    subtitle?: string;
    title?: string;
    onExpandClick?: () => void;
}

const GrossEarningsCard: React.FC<GrossEarningsCardProps> = ({
    amount = "3.500,00 Bs.s",
    subtitle = "Ganancias totales del conductor:",
    title = "Ganancias brutas",
    onExpandClick = () => { }
}) => {
    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                width: '100%'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2
                }}
            >
                <Typography variant="h6" component="h2" fontWeight="500">
                    {title}
                </Typography>

                <IconButton
                    size="small"
                    onClick={onExpandClick}
                    sx={{ color: 'text.primary' }}
                >
                    <OpenInNewIcon fontSize="small" />
                </IconButton>
            </Box>

            <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 1 }}
            >
                {subtitle}
            </Typography>

            <Typography
                variant="h3"
                component="div"
                fontWeight="600"
                sx={{
                    mt: 1,
                    fontSize: { xs: '1.75rem', sm: '2.5rem' }
                }}
            >
                {amount}
            </Typography>
        </Paper>
    );
};

export default GrossEarningsCard;